import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { NumberPresenterV2Component } from './number-presenter-v2.component';


@NgModule({
  declarations: [NumberPresenterV2Component],
  exports: [
    NumberPresenterV2Component,
  ],
  imports: [
    CommonModule,
  ],
})
export class NumberPresenterV2Module { }
